// @ts-nocheck
import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import {
  fertigationDecoderFields,
  hasDecoderLink,
  storedDecoderOrUndefined,
} from '@/utils/decoderLink'
import hydraulicDataConfig from '@/api/config/hydraulicDataConfig'
import Select from '@/components/form-control/Select'
import { useAuthContext } from '@/features/auth/context'
import { useConfigUI } from '@/features/config/context'
import useDetailFertigationGlobal from '@/features/config/hooks/fertigation/useDetailFertigationGlobal'
import useGlobalExclusionTime from '@/features/config/hooks/fertigation/useGlobalExclusionTime'
import { NotifyService } from '@/helpers'
import { usePermission } from '@/hooks/permissions'
import useTranslation from '@/hooks/useTranslation'
import { DATA_PAGINATION } from '@/types'
import { yupResolver } from '@hookform/resolvers/yup'
import { LoadingButton } from '@mui/lab'
import {
  Button,
  CircularProgress,
  Container,
  Fade,
  Stack,
  Typography,
} from '@mui/material'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'


interface FertigationGlobalExclusionProps {
  id?: string
  name?: string
}

const schema = yup
  .object({
    controller: yup
      .mixed()
      .required('Main Valve is required')
      .test('has-decoder', 'Main Valve is required', (value) =>
        hasDecoderLink(value),
      ),
    pipe: yup
      .mixed()
      .required('Main Line is required')
      .test('has-pipe', 'Main Line is required', (value) => !!value?.id),
  })
  .required()

const FertigationGlobalExclusion = ({
                                      id,
                                      name,
                                    }: FertigationGlobalExclusionProps) => {
  const { closeSidebar } = useConfigUI()
  const { interfaceId } = useAuthContext()
  const { data: dataItem, isFetching } = useDetailFertigationGlobal(interfaceId)
  const {
    mutate: apply,
    isLoading: loadingApply,
    isSuccess: isApplySuccess,
    isError: isApplyError,
  } = useGlobalExclusionTime()

  const { isViewOnly } = usePermission()
  const { t } = useTranslation()

  // const inputRefName = useRef<HTMLInputElement>(null)

  // useEffect(() => {
  //   if (inputRefName.current) {
  //     inputRefName.current.focus()
  //   }
  // }, [])

  const form = useForm({
    resolver: yupResolver(schema),
  })

  console.log({ dataItem })

  useEffect(() => {
    if (dataItem) {
      form.reset({
        controller: storedDecoderOrUndefined({
          id: dataItem.decoderId,
          address: dataItem.address,
          index: dataItem.controllerId,
          name: dataItem.decoderName || dataItem.controllerName,
        }),
        pipe: dataItem.pipeId
          ? { id: dataItem.pipeId, description: dataItem.pipeName }
          : undefined,
        id: id,
      })
    }
    // eslint-disable-next-line
  }, [dataItem, form])
  const handleSave = (data: any) => {
    if (isViewOnly) return
    apply({
      interfaceId: interfaceId,
      ...fertigationDecoderFields(data.controller),
      pipeId: data.pipe.id,
    })
  }

  const getOptionsMainController =
    () => async (PageIndex?: number, PageSize?: number, Keyword?: string) => {
      let data: DATA_PAGINATION | undefined
      data = await controllerDataConfigApi
        .getAll({
          interfaceId,
          PageIndex,
          PageSize: PageSize || 20,
          Keyword,
          isRequiredStation: true,
        })
        .then((res) => res.data)
        .catch((e) => {
          NotifyService.error(e)
          return undefined
        })
      return data
    }
  const getOptionsMainPipe =
    () => async (PageIndex?: number, PageSize?: number, Keyword?: string) => {
      let data: DATA_PAGINATION | undefined
      data = await hydraulicDataConfig
        .getAll({
          interfaceId,
          PageIndex,
          PageSize: PageSize || 20,
          Keyword,
        })
        .then((res) => res.data)
        .catch((e) => {
          NotifyService.error(e)
          return undefined
        })
      return data
    }

  return (
    <Container sx={{ maxWidth: '450px', height: '100%' }}>
      {isFetching ? (
        <Stack
          width="377px"
          height="100%"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Stack>
      ) : (
        <Fade in={!isFetching}>
          <form onSubmit={form.handleSubmit(handleSave)}>
            <Stack sx={{ padding: '34px 18px' }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: '377px' }}
                marginBottom={2}
              >
                <Typography
                  sx={{
                    fontWeight: '500',
                    lineHeight: '14px',
                    color: 'text.main',
                  }}
                >
                  {t('FertigationGlobalSettings')}
                </Typography>
                <Stack direction="row">
                  <Button
                    variant="secondary"
                    sx={{ marginRight: '7px', width: '85px', height: '26px' }}
                    onClick={() => closeSidebar()}
                    type="button"
                  >
                    {t('commonActionsClose')}
                  </Button>
                </Stack>
              </Stack>
              <Select
                minWidth={'100%'}
                isHasMore
                filterFunc={false}
                label= {t('formsLabelsMainLine')}
                name="pipe"
                bindLabel="description"
                bindKey="description"
                placeholder= {t('formsPlaceholdersSelectOne')}
                form={form}
                getOptions={getOptionsMainPipe()}
              />
              <Select
                minWidth={'100%'}
                isHasMore
                filterFunc={false}
                label={t('formsLabelsMainValve')}
                name="controller"
                bindLabel="name"
                bindKey="name"
                placeholder={t('formsPlaceholdersSelectOne')}
                form={form}
                getOptions={getOptionsMainController()}
              />
              {/* {isApplyError || isApplySuccess ? (
                <Typography
                  color={isApplySuccess ? '#004748' : '#ff3030'}
                  fontSize={'14px'}
                  fontWeight={500}
                  marginTop={1}
                >
                  Configuration is {isApplyError && 'not'} applied!
                </Typography>
              ) : null} */}
              <Stack direction="row" justifyContent={'flex-end'} mt={2}>
                {/* <Button
                  variant="secondary"
                  sx={{
                    marginRight: '7px',
                    width: '85px',
                    height: '26px',
                    opacity: 0.1,
                  }}
                  // onClick={() => closeSidebar()}
                  type="button"
                  // disabled
                >
                  Refresh
                </Button> */}
                <LoadingButton
                  disabled={isViewOnly}
                  loading={loadingApply}
                  variant={isViewOnly ? 'outlined' : 'primary'}
                  size="small"
                  sx={{ minWidth: '85px', height: '26px' }}
                  type="submit"
                >
                  {t('commonActionApplyConfiguration')}
                </LoadingButton>
              </Stack>
            </Stack>
          </form>
        </Fade>
      )}
    </Container>
  )
}

export default FertigationGlobalExclusion
